export class WebhookV1BackupJobDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "policyName",
            "baseName": "policyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountName",
            "baseName": "sourceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "duration",
            "baseName": "duration",
            "type": "WebhookV1ProtobufDuration",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotSizeBytes",
            "baseName": "snapshotSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1BackupJobDetails.attributeTypeMap;
    }
    constructor() {
    }
}
